/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamCertifikacniAutorita extends GContentBase<SeznamCertifikacniAutoritaObj> {
        private seznamObj: SeznamCertifikacniAutoritaObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamCertifikacniAutoritaObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamCertifikacniAutoritaNew",
                contentCaption: "jres:33000103",
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{jmeno}"
                },
                gridSettings: {
                    columnOrder: "jmeno,stat,ulice,obec,firma,utvar,email,id_cert,otisk,poznamka,adresa,tel,priz_akr_txt,priz_eu_tsl_txt,status,typ_cert,dat_zmena"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamCertifikacniAutoritaObj extends GAdmSeznamBase {
        private registerAsyncClass: string = "Gordic.AdmIsl.Server.LoadCertificatesEUAsync";

        create() {
            this.initAsyncTaskLoadCertificates();
        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailCertifikacniAutorita", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailCertifikacniAutorita",
                newRecord: isNew,
                ixs_cau: isNew == true ? null : data.ixs_cau
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actImportCertificate: {
                    icon: "gi-sign",
				    caption: "jres:33000050",
                    run: () => {
                        this.importCertificate();
                    }
                },
                actLoadCertificatesEU: {
                    icon: "gi-sign",
                    caption: "jres:33000044", //RC 33000044 : Na�ten� certifik�t� z EU
                    run: () => {
                        this.nacteniCertifikatuEU();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actImportCertificate*", "actLoadCertificatesEU*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenDialogVyberovaSkupina*"])
        }

        createFilterForm() {

        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.CertifikacniAutorita.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.ixs_cau),
                nazev: data["jmeno"]
            }
        }

        private importCertificate() {
            this.cnt.dialogs.showModalWindow("Gordic.Adm.WebControls.DialogImportCertifikacniAutorita", null, { width: 500, height: 230 }).on("close", (ev, o) => {
                if (o == true) {
                    this.cnt.beginOperation();
                    this.applydata(this.filterData);
					this.cnt.endOperation();
				}
			})
        }

        private nacteniCertifikatuEU() {
			var testRunning = Async.GTaskManager.findByClass(this.registerAsyncClass).length > 0 ? true : false;
			if (testRunning == false)
				Async.GTaskManager.start(this.registerAsyncClass, {}, { clearOnFinish: true, autoClean: true })
			else
				GDlg.warning("jres:33000045", "jres:33000046") //RC 33000046 : �lohu nelze spustit v�cekr�t!
				
        }

        private initAsyncTaskLoadCertificates() {
            if (Async.GTaskManager.getAllTasks().find(item => item.className == this.registerAsyncClass) == undefined) {
            	Async.GTaskManager.on("init", this.registerAsyncClass, function (o) {
            		var currentDate = new Date();
            		var exportNotId = "adm-load-certificates-EU-{0}{1}{2}".format(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds());
            		var notif: IGNotificationOptions = {
            			id: exportNotId,
            			title: "jres:29809454",
            			icon: "fa-info-circle",
            			content: "jres:33000041" //RC 33000041 : Prob�h� na��t�n� certifik�t� z EU
            		}
            		var not = new GObservableObject(notif);
            		this.customDto = { not: not, id: exportNotId };
            		$.content($("#main")).notification("add", notif, true);
            	})
            	Async.GTaskManager.on("always", this.registerAsyncClass, function (o) {
            		this.customDto = {};
            		$.content($("#main")).notification("remove", this.customDto.id);
            		this.clean();
            	})
            	Async.GTaskManager.on("fail", this.registerAsyncClass, function (o) {
            		$.content($("#main")).notification("remove", this.customDto.id);
            		this.customDto = {};
            		var notifError: IGNotificationOptions = {
            			icon: "fa-exclamation-circle",
            			shortTemplate: "<b>jres:29809454</b><br /><span>jres:33000042</span>",  //RC 33000042 : Chyba p�i na�ten� certifik�t� z EU
            			content: {},
            			state: "error",
            		}
                    $.content($("#main")).notification("add", notifError, true);
            		this.clean();
            	})
            	Async.GTaskManager.on("done", this.registerAsyncClass, function (o) {
            		$.content($("#main")).notification("remove", this.customDto.id);
            		var currentDate = new Date();
            		var id = "adm-load-certificates-EU-success-{0}{1}{2}".format(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds());
            		var cnt = $.content($("#main"));
            		var notifOk: IGNotificationOptions = {
            			id: id,
            			icon: "fa-check-circle",
            			shortTemplate: "<b>jres:29809454</b><br /><span>jres:33000043</span>", //RC 33000043 : Na�ten� certifik�t� z EU skon�ilo �sp�n�
            			state: "success",
            			content: {}
            		}
            		cnt.notification("add", notifOk, true);
            	})
            }
        }
    }
}
